export default __webpack_public_path__ + "static/media/cart-dark.4f95fb17.svg";